/**
 * main idea of this file from here:
 * https://github.com/mgalante/jquery.redirect
 *
 * This library creates form from an URL on the fly and submits it.
 * 
 * basic ussage: 
 * postUrl
        'https://www.example.com',
        '_blank'
      );
 */

/**
 * Adds the created form with the parameters to the DOM
 * Submits it
 * and remove it from the DOM
 * @param {String} url
 * @param {String} target
 * @param {Boolean} traditional 
 */
export const postUrl = function (url, target, traditional) {
  let generatedForm = postUrl.getForm(url, target, traditional);
  document.body.appendChild(generatedForm.form);
  generatedForm.submit();
  document.body.removeChild(generatedForm.form);
};


/**
 * This method creates de form to be submited
 * @param {String} url 
 * @param {String} target 
 * @param {*} traditional 
 * @returns Object
 */
postUrl.getForm = function (url, target, traditional) {
  let method = 'POST';

  url = url.split('#');
  let hash = url[1] ? '#' + url[1] : '';
  url = url[0];

  let obj = parseUrl(url);
  url = obj.url;
  let values = obj.params;
  values = removeNulls(values);

  let form = document.createElement('form');
  form.method = method;
  form.action = url + hash;

  if (target) {
    form.target = target;
  }

  let submit = form.submit;
  iterateValues(values, [], form, null, traditional);

  return {
    form: form,
    submit: function () {
      submit.call(form);
    }
  };
};

//Utility Functions
/**
 * Url and QueryString Parser.
 * @param {string} url - a Url to parse.
 * @returns {object} an object with the parsed url with the following structure {url: URL, params:{ KEY: VALUE }}
 */
let parseUrl = function (url) {
  if (url.indexOf('?') === -1) {
    return {
      url: url,
      params: {}
    };
  }
  let parts = url.split('?'),
    query_string = parts[1],
    elems = query_string.split('&');
  url = parts[0];

  let i,
    pair,
    obj = {};
  for (i = 0; i < elems.length; i += 1) {
    pair = elems[i].split('=');
    obj[pair[0]] = pair[1];
  }

  return {
    url: url,
    params: obj
  };
};

//Private Functions
/**
 * Creates an input to be added to the form.
 * @param {String} name 
 * @param {String} value 
 * @param {Array} parent 
 * @param {Boolean} array 
 * @param {Boolean} traditional 
 * @returns Element (input)
 */
let getInput = function (name, value, parent, array, traditional) {
  let parentString;
  if (parent.length > 0) {
    parentString = parent[0];
    let i;
    for (i = 1; i < parent.length; i += 1) {
      parentString += '[' + parent[i] + ']';
    }

    if (array) {
      if (traditional) name = parentString;
      else name = parentString + '[' + name + ']';
    } else {
      name = parentString + '[' + name + ']';
    }
  }
  let anInput = document.createElement('input');
  anInput.value = value;
  anInput.name = name;
  anInput.type = 'hidden';

  return anInput;
};

/**
 * Turns every parameter in the URL (now values) into an input and append them
 * into the form.
 * @param {Object} values 
 * @param {Array} parent 
 * @param {Element} form 
 * @param {*} isArray 
 * @param {*} traditional The brackets are omitted on the field name if its an array. 
 */
let iterateValues = function (values, parent, form, isArray, traditional) {
  let i,
    iterateParent = [];
  Object.keys(values).forEach(function (i) {
    if (typeof values[i] === 'object') {
      iterateParent = parent.slice();
      iterateParent.push(i);
      iterateValues(values[i], iterateParent, form, Array.isArray(values[i]), traditional);
    } else {
      form.append(getInput(i, values[i], parent, isArray, traditional));
    }
  });
};

let removeNulls = function (values) {
  let propNames = Object.getOwnPropertyNames(values);
  for (let i = 0; i < propNames.length; i++) {
    let propName = propNames[i];
    if (values[propName] === null || values[propName] === undefined) {
      delete values[propName];
    } else if (typeof values[propName] === 'object') {
      values[propName] = removeNulls(values[propName]);
    } else if (values[propName].length < 1) {
      delete values[propName];
    }
  }
  return values;
};
